/**
 * The ONE ordering of an event's carbon-website sites (ACTIVE-SITE CONTRACT, doc/website-v2/PLAN.md),
 * shared by `useWebsiteV2Sites` and the server's `resolveCarbonGuestSite` so the site
 * the editor treats as current and the site withjoy.com/:handle serves can never disagree.
 *
 * Live sites first, most recently published (`publishedAt ?? updatedAt`) first; drafts follow,
 * latest-updated first. `id` breaks exact ties so the order never depends on row order from the
 * service.
 */
export type WebsiteV2SiteOrderRow = Readonly<{
  id: string;
  published: boolean;
  publishedAt?: unknown;
  updatedAt: unknown;
}>;

// `updatedAt` / `publishedAt` are the `Timestamp` scalar (typed `any`); the service serializes an
// ISO string but be tolerant of epoch millis.
export const toMillis = (timestamp: unknown): number => (typeof timestamp === 'number' ? timestamp : Date.parse(String(timestamp)) || 0);

export const compareWebsiteV2Sites = (a: WebsiteV2SiteOrderRow, b: WebsiteV2SiteOrderRow): number => {
  if (a.published !== b.published) return a.published ? -1 : 1;
  const byTime = a.published ? toMillis(b.publishedAt ?? b.updatedAt) - toMillis(a.publishedAt ?? a.updatedAt) : toMillis(b.updatedAt) - toMillis(a.updatedAt);
  if (byTime !== 0) return byTime;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
};
